import { formDataType } from "../AddSite";
import { QuillEditor } from "../../../../components/QuillEditor";

interface ScopeOfWorkProps {
  formData: formDataType;
  setFormData: React.Dispatch<React.SetStateAction<formDataType>>;
  fieldErrors?: { [key: string]: string };
}

export function ScopeOfWork({ formData, setFormData, fieldErrors }: ScopeOfWorkProps) {
  return (
    <div>
      <QuillEditor
        label="Scope Of Work"
        content={formData.scope_of_work}
        setContent={val => {
          setFormData({
            ...formData,
            scope_of_work: val,
          });
        }}
        required={true}
        hidePlaceholder={true}
        error={fieldErrors?.["scope_of_work"]}
      />
    </div>
  );
}
